import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const CHANGE_EMPLOYEE = NS + 'CHANGE_EMPLOYEE'

export const SET_SIPGATE_DEVICE_ID_REQUEST = NS + 'SET_SIPGATE_DEVICE_ID_REQUEST'
export const SET_SIPGATE_DEVICE_ID_SUCCESS = NS + 'SET_SIPGATE_DEVICE_ID_SUCCESS'
export const SET_SIPGATE_DEVICE_ID_ERROR = NS + 'SET_SIPGATE_DEVICE_ID_ERROR'




// WEBPACK FOOTER //
// ./src/modules/employee/state/type.js